import {GetDefaultIndex} from '../../components';
import { useGetIndustriesCommonInfoQuery } from "../../features/api/apiSlice";
import {useIndustryRoutes} from './routes';

export {useIndustryRoutes};

export default GetDefaultIndex({title: 'صنایع', query: useGetIndustriesCommonInfoQuery});
